import { SellerInfo } from '../../entities/SellerInfo'
import { httpClient } from '../http/httpClient'

export async function sellerInfo(id: string) {
  const { data } = await httpClient.get<SellerInfo>(`/user/${id}`, {
    headers: {
      'x-mock-response-name': 'Get user by ID',
    },
  })

  return data
}
